<template>
    <div>
        <b-row>
            <b-col cols="12" lg="6" v-for="(index, item) in datas" v-bind:key="item">
                <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" :label="item" label-for="filter-survey-main-customer">
                    <label class="p-value">{{ index }}</label>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row style="margin-top: -30px">
            <b-col>
                <b-button size="sm" class="float-right float-bottom" :to="{path: '/inbox/' + entityRoute + statusRoute + '/' + this.documentId}">Details</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: ["entityName","documentId", "approvalStatus"],
    data() {
        return {
            datas: [],
            entityRoute: '',
            statusRoute: ''
        }
    },
    methods : {
        getInboxDetails() {
            console.log(this.entityName);
            let entityName = this.entityName.split(' ').join('').toLowerCase();
            this.$http.get(process.env.VUE_APP_API_URL + entityName + '/inbox/' + this.documentId).then(result => {
                this.datas = result.data;
            });
        }
    },
    mounted() {
        this.getInboxDetails();
        this.entityRoute = this.entityName.split(' ').join('').toLowerCase();
        this.statusRoute = this.approvalStatus.split(' ').join('').toLowerCase();
        console.log(this.entityRoute + this.statusRoute);
    }
}
</script>